import { Link as NavLink } from '@material-ui/core';

export const Website = () => <NavLink href='https://spores.app'>www.spores.app</NavLink>;

export const Email = () => <NavLink href='mailto:support@spores.app'>support@spores.app</NavLink>;
